import Confirm from './Confirm';

export default Confirm;



// WEBPACK FOOTER //
// ./src/common/components/Confirm/index.js